export function initMobileMenu() {
    $('.hamburger').click(function () {
        $('body').toggleClass('mobile-menu-open', $(this).hasClass('is-active'));
    });
}